<template>
    <div class="container remove-padding-margin">
        <div class="fixed-top fixed-judul">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-1 col-sm-1 col-1 remove-padding" @click="back">
                    <img src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-10 col-sm-10 col-10 text-center remove-padding">
                  {{`${isEditMode ? "Ubah" : "Tambah"}  Paket Deposit`}}
                </div>
                <div class="col-md-1 col-sm-1 col-1 remove-padding">
                </div>
            </div>
        </div>
        <main class="add-padding-default">
            <div class="flex-100">
                <div class="flex-1">
                    <form action="">
                        <div class="form-group set-margin">
                            <div class="m-t-12" v-if="!isEditMode">
                                <label 
                                  class="m-0 require f-regular f-14 f-c-midgrey" 
                                  for="jenis-paket-deposit"
                                >
                                    Jenis Paket
                                </label>
                                <SOInputOnOff 
                                  :checkboxes="jenisDeposit" 
                                  @selected="(e) => { toogleOnOff(e, 'jenis_deposit') }" 
                                  :checked="deposit.jenis_deposit == 1 ? true : false"
                                />
                                <div class="p-y-8 p-x-20 bg-yellow text-white m-t-12 mx-min-20">
                                    <label class="f-12 f-c-midgrey f-regular m-0">
                                        <img src="../../assets/icons/alert-circle-yellow.svg"/>
                                        Jenis paket tidak dapat diubah setelah disimpan.
                                    </label>
                                </div>
                            </div>
                            <div class="m-t-12 f-14 f-regular" v-if="isEditMode">
                              <label class="f-c-midgrey">Jenis Paket:</label>
                              <label class="f-c-black" style="padding-left : 5px">{{titleJenisDeposit}}</label>
                            </div>
                            <div class="separator mx-min-20"></div>
                            <div class="m-t-12">
                                <SOInputRegular
                                  :title="'Nama Paket Deposit'"
                                  :placeholder="'Cuci Kering Setrika'"
                                  :validation="'alphanumeric'"
                                  :required="true"
                                  v-model="deposit.nama_paket"
                                  @input="handleInput($event, 'nama_paket')"
                                />
                                <ErrorMessage 
                                  class="error" 
                                  label="Nama Paket Deposit"
                                  :validation="$v.deposit.nama_paket"
                                />
                            </div>
                            <div class="m-t-12">
                                <SOInputSelect
                                  :title="'Layanan Yang Terhubung'"
                                  :placeholder="'Pilih layanan'"
                                  :options="optionslayanan"
                                  :required="true"
                                  :selected="deposit.idlayanan"
                                  @option-selected="hanldeSelected($event)"
                                />
                                <ErrorMessage 
                                  class="error" 
                                  label="Layanan Yang Terhubung"
                                  :validation="$v.deposit.idlayanan"
                                />
                            </div>
                            <div class="form-row m-t-12">
                                <div class="form-group col-md-6 col-sm-6 col-6">
                                    <SOInputNominal
                                      :title="'Kuota Paket'"
                                      :required="true"
                                      :use-comma="true"
                                      :prefix-right="true"
                                      :placeholder="'Isi paket'"
                                      :prefix="satuan"
                                      :defaultValue="inputNominal.kuota_paket.formatted"
                                      v-model="inputNominal.kuota_paket"
                                      @input="handleNominalChange($event, 'jumlah')"
                                    />
                                    <ErrorMessage 
                                      class="error" 
                                      label="Kuota Paket"
                                      :validation="$v.deposit.jumlah"
                                    />
                                </div>
                                <div class="form-group col-md-6 col-sm-6 col-6">
                                    <SOInputNominal
                                      :title="'Diskon'"
                                      :is-percent="true"
                                      :use-comma="true"
                                      :placeholder="'0'"
                                      :prefix-right="true"
                                      :prefix="'%'"
                                      :defaultValue="inputNominal.diskon.formatted"
                                      v-model="inputNominal.diskon"
                                    />
                                </div>
                            </div>
                            <div class="d-block">
                                <div class="m-t-12">
                                    <label class="f-regular f-16 f-c-black m-0">Harga paket:</label>
                                    <label class="f-semi f-c-black f-16 m-0" style="padding-left: 5px">
                                      {{`Rp ${formatRupiah(hargaPaket.toString())}`}}
                                    </label>
                                </div>
                                <label class="f-regular f-12 f-c-midgrey m-0">
                                    Harga layanan x Kuota paket - diskon
                                </label>
                            </div>
                            <!-- Tampilkan ketika deposit.jenis_deposit == 1 (limited)  -->
                            <div id="detail-masa-aktif" v-if="deposit.jenis_deposit == 1">
                                <div class="separator m-t-12 mx-min-20"></div>
                                <div id="masa-aktif" class="m-t-12">
                                    <SOInputNominal
                                      :title="'Masa Aktif Paket'"
                                      :required="true"
                                      :prefix-right="true"
                                      :placeholder="'30'"
                                      :prefix="'Hari'"
                                      :defaultValue="inputNominal.masa_aktif_hari.formatted"
                                      v-model="inputNominal.masa_aktif_hari"
                                      @input="handleNominalChange($event, 'masa_aktif_hari')"
                                    />
                                    <ErrorMessage 
                                      class="error" 
                                      label="Masa Aktif Paket"
                                      :validation="$v.deposit.masa_aktif_hari"
                                    />
                                </div>

                                <div class="m-t-12">
                                  <SoModalOptions
                                    :title="modalOptions.masaAktifPaket.title"
                                    :selectedOption="deposit.tipe_perpanjangan_masa_aktif"
                                    :options="modalOptions.masaAktifPaket.options"
                                    :id="'akumulasi-masa-aktif'"
                                    :required="true"
                                    @onSelected="obj => { selectedOption(obj, 'tipe_perpanjangan_masa_aktif') }"
                                  />
                                  <ErrorMessage 
                                    class="error" 
                                    label="Masa Aktif Paket"
                                    :validation="$v.deposit.tipe_perpanjangan_masa_aktif"
                                  />
                                </div>
                                <div class="m-t-12">
                                  <SoModalOptions
                                    :title="modalOptions.jikaKedaluarsa.title"
                                    :selectedOption="deposit.tipe_quota_expired"
                                    :options="modalOptions.jikaKedaluarsa.options"
                                    @onSelected="obj => { selectedOption(obj, 'tipe_quota_expired') }"
                                    :id="'tipe-quota-expired'"
                                    :required="true"
                                  />
                                  <ErrorMessage 
                                    class="error" 
                                    label="Jika Kedaluarsa"
                                    :validation="$v.deposit.tipe_quota_expired"
                                  />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="button-lanjut ">
                    <button 
                      class="btn btn-login btn-long remove-margin" 
                      id="btnSimpanTambahDeposit"
                      :disabled="isSubmit"
                      @click="saveDeposit"
                    >
                        <span 
                          class="spinner-border spinner-border-sm" 
                          role="status" 
                          aria-hidden="true"
                          v-if="isSubmit == true">
                        </span>
                        <span id="textBtn2" v-if="isSubmit != true">
                            Simpan
                        </span>
                    </button>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import ErrorMessage from "@/component-items/ErrorMessage";
    import SOInputNominal from "@/so-components/global/input/SOInputNominal";
    import SOInputSelect from "@/so-components/global/input/SOInputSelect";
    import SOInputRegular from "@/so-components/global/input/SOInputRegular";
    import SOInputOnOff from "@/so-components/global/input/SOInputOnOff";
    import SoModalOptions from '@/so-components/global/ui/SOModalOptions';
    import connection from '@/store/utils/connection';
    import {minValue, minLength, required} from "vuelidate/lib/validators";

    const masaAktif = {
      limited : "Dengan Masa Aktif",
      unlimited : "Tanpa Masa Aktif (Unlimited)"
    }

    const jenisDeposit = (title = masaAktif.limited) => ({
        name: "jenis-paket",
        data: [
            {
                id: "jenis-paket-deposit",
                value: "1",
                title: `<label class='f-regular f-16 f-c-black m-0' for='jenis-paket-deposit'>${title}</label>`,
                checked: false,
                titleBold: false,
            },
        ]
    })

    export default {
        name: "TambahDeposit",
        components: {
            ErrorMessage,
            SOInputNominal,
            SOInputSelect,
            SOInputRegular,
            SoModalOptions,
            SOInputOnOff
        },
        props: {
            setidoutletsetdeposit:  {
                type: String,
                required: true
            },
            iddeposit: {
                type: Number
            }
        },
        data() {
            return {
                deposit : {
                    idoutlet: this.setidoutletsetdeposit,
                    nama_paket: "",
                    idlayanan: "",
                    harga_layanan: 0,
                    jumlah: 0,
                    harga_paket: 0,
                    jenis_deposit: "", //default 1 (limited) || 2 (unlimited)
                    tipe_perpanjangan_masa_aktif: "",
                    tipe_quota_expired: "",
                    masa_aktif_hari: "",
                },
                inputNominal : {
                    masa_aktif_hari: {},
                    kuota_paket: {},
                    diskon: {
                        raw: 0,
                        formatted: "",
                    },
                },
                modalOptions: {
                    masaAktifPaket:{
                        title: "Tipe Masa Aktif",
                        options : [
                            {
                                value : 1,
                                title : "Akumulasi",
                                information: "Masa aktif akan bertambah (terakumulasi) setiap pembelian paket."
                            },
                            {
                                value : 2,
                                title : "Terlama",
                                information: "Masa aktif akan dipilih yang terlama antara sisa masa aktif dan jumlah masa aktif paket yang dibeli."
                            },
                            {
                                value : 3,
                                title : "Terbaru",
                                information: "Masa aktif paket yang dibeli akan menggantikan sisa masa aktif yang ada."
                            },
                        ]
                    },
                    jikaKedaluarsa:{
                        title: "Jika Kedaluarsa",
                        options : [
                            {
                                value : 1,
                                title : "Hangus",
                                information: "Sisa kuota paket akan hangus dan tidak bisa digunakan kembali, jika masa aktif habis."
                            },
                            {
                                value : 2,
                                title : "Roll-Up",
                                information: "Sisa kuota paket akan tersimpan, meskipun masa aktif habis & akan terakumulasi saat membeli lagi paket yang sama."
                            },
                        ]
                    },
                },
                isSubmit: false,
                satuan: '',
                optionslayanan: [],
                jenisDeposit: jenisDeposit(),
            }
        },
        validations: {
            deposit: {
                nama_paket : {
                    required,
                    minLength: minLength(2),
                },
                idlayanan : {
                    required
                },
                jumlah: {
                    required,
                    minValue: minValue(0.01)
                },
                masa_aktif_hari: {
                    required,
                    minValue: minValue(1)
                },
                tipe_perpanjangan_masa_aktif : {
                    required
                },
                tipe_quota_expired: {
                    required
                }
            }
        },
        mounted() {
            this.getlayananselect()
            this.toogleOnOff(true, "jenis_deposit")
            this.backButtonPressed(this.back)
            // When Update
            this.detaildeposit()
        },
        watch: {
            "inputNominal.diskon.raw": function () {
                this.countHargaPaket();
            },
            "deposit.jenis_deposit": function (jenisBaru, jenisLama) {
                if (jenisBaru !== jenisLama) {
                    if (jenisBaru == 1) {
                        this.jenisDeposit = jenisDeposit();
                    } else if (jenisBaru == 2) {
                        this.jenisDeposit = jenisDeposit(masaAktif.unlimited);
                    }
                }
            },
            immediate: true
        },
        computed: {
            hargaPaket: function () {
                return this.countHargaPaket();
            },
            apiEndPoint: function () {
                return {
                    create : `${this.$baseurl}/masterData/deposit/create_deposit_v2`,
                    update : `${this.$baseurl}/masterData/deposit/update_deposit_v2?iddeposit=${this.iddeposit}`,
                    dataDeposit: `${this.$baseurl}/masterData/meta/data_detail_deposit`,
                    detailLayanan : `${this.$baseurl}/masterData/meta/detail_layanan`,
                    selectLayanan: `${this.$baseurl}/masterData/meta/list_select_layanan_meta`,
                }
            },
            isEditMode: function () {
                return this.iddeposit ? true : false;
            },
            titleJenisDeposit: function () {
                return this.deposit.jenis_deposit == 1 ? masaAktif.limited : masaAktif.unlimited;
            }
        },
        methods: {
            back() {
                this.$emit('gotolistdeposit')
            },
            async hanldeSelected(idlayanan) {
                this.deposit.idlayanan = idlayanan
                await this.gettahapandeposit()
                this.countHargaPaket();
            },
            handleInput(event, target) {
                this.deposit[target] = event
            },
            handleNominalChange(event, target){
                this.deposit[target] = event.raw;
            },
            toogleOnOff(isChecked, target) {
                let jenisDeposit = 2;
                if (isChecked) {
                    jenisDeposit = 1;
                    if (!this.deposit.tipe_perpanjangan_masa_aktif) {
                        this.deposit.tipe_perpanjangan_masa_aktif = 1;
                    }

                    if (!this.deposit.tipe_quota_expired) {
                        this.deposit.tipe_quota_expired = 1;
                    }
                }
                this.deposit[target] = jenisDeposit;
            },
            selectedOption(obj, target) {
                this.deposit[target] = obj.value;
            },
            countHargaPaket() {
                let { harga_layanan, jumlah } = this.deposit;
                let diskon = this.inputNominal.diskon.raw;

                let hargaDiskon = harga_layanan * (parseFloat(diskon) / 100);
                let hargaSatuan = harga_layanan - hargaDiskon;
                let hargaPaket  = hargaSatuan * jumlah;

                this.deposit.harga_paket = hargaPaket;
                return hargaPaket;
            },
            nominalFormat(value) {
                if (typeof(value) !== "number") {
                    return {
                        raw: 0,
                        formatted: "0"
                    }
                }
                
                return {
                    raw: value,
                    formatted: Number.isInteger(value) ? value.toString() : value.toFixed(2).toString().replace(".", ",")
                }
            },
            async detaildeposit() {
                if (!this.isEditMode) {
                  return;
                }
                
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await connection.get(
                        this.apiEndPoint.dataDeposit,
                        { iddeposit:this.iddeposit }
                    );

                    if (response.data.status) {
                        let { data } = response.data;
                        let deposit = data[0];
                        let duration = this.$moment.duration(deposit.masa_aktif, 'milliseconds').asDays();
                        let { harga_deposit, harga_layanan, jumlah, jenis_deposit } = deposit;

                        this.deposit.nama_paket = deposit.nama;
                        this.deposit.idlayanan = deposit.layanan_idlayanan;
                        this.satuan = deposit.layanan.satuan.nama;
                        this.deposit.jenis_deposit = jenis_deposit;
                        this.deposit.harga_layanan = harga_layanan;
                        // Jumlah Deposit
                        this.deposit.jumlah = jumlah;
                        this.inputNominal.kuota_paket = this.nominalFormat(jumlah);
                        // Masa Aktif, Tipe Quota, Tipe Masa Aktif
                        this.deposit.tipe_perpanjangan_masa_aktif="";
                        this.deposit.tipe_quota_expired= "";

                        if (jenis_deposit === 1) {
                            this.deposit.tipe_perpanjangan_masa_aktif=deposit.tipe_perpanjangan_masa_aktif;
                            this.deposit.tipe_quota_expired= deposit.tipe_quota_expired;
                            this.deposit.masa_aktif_hari = duration;
                            this.inputNominal.masa_aktif_hari = this.nominalFormat(duration);
                        }
                        // Count Diskon
                        let hrgBruto = harga_layanan * jumlah;
                        let hrgNetto = harga_deposit;
                        let diskon   = (hrgBruto - hrgNetto) / hrgBruto * 100;

                        this.inputNominal.diskon = this.nominalFormat(diskon);
                      
                    } else {
                        this.$toast.error(response.data.msg);
                    }
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').removeClass('overlayLoading');
                    $('#loadingPage').hide();
                }
            },
            async gettahapandeposit() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await connection.get(
                        this.apiEndPoint.detailLayanan, 
                        { idlayanan: this.deposit.idlayanan, idoutlet: this.deposit.idoutlet }
                    );
                    
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            this.satuan = response.data.data.layanan.satuan.nama
                            this.deposit.harga_layanan = response.data.data.harga
                        }
                    } else {
                        this.$toast.error(response.data.msg);
                    }
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },

            async getlayananselect() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await connection.get(
                        this.apiEndPoint.selectLayanan, 
                        { idoutlet: this.setidoutletsetdeposit }
                    );
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            var layanan = response.data.data;
                            this.optionslayanan.push({id: "", text: "Pilih Layanan"})
                            for (var i = 0; i < layanan.length; i++) {
                                this.optionslayanan.push({
                                    id: layanan[i].layanan.idlayanan,
                                    text: layanan[i].layanan.nama_layanan
                                })
                            }
                        }
                    } else {
                        this.$toast.error(response.data.msg);
                    }
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#loadingPage').hide();
                    $('#loadingPage').removeClass('overlayLoading');
                }
            },

            errorValidation() {
                this.$v.deposit.nama_paket.$touch();
                this.$v.deposit.idlayanan.$touch();
                this.$v.deposit.jumlah.$touch();

                let isValid = this.$v.deposit.nama_paket.$invalid || 
                    this.$v.deposit.idlayanan.$invalid ||
                    this.$v.deposit.jumlah.$invalid

                if (this.deposit.jenis_deposit == 1) {
                    this.$v.deposit.masa_aktif_hari.$touch();
                    this.$v.deposit.tipe_perpanjangan_masa_aktif.$touch();
                    this.$v.deposit.tipe_quota_expired.$touch();

                    isValid = isValid || 
                        this.$v.deposit.masa_aktif_hari.$invalid ||
                        this.$v.deposit.tipe_perpanjangan_masa_aktif.$invalid ||
                        this.$v.deposit.tipe_quota_expired.$invalid
                }
                
                return isValid;
            },
            async saveDeposit() {
                if (this.errorValidation()) {
                    this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
                    return
                }
                
                this.isSubmit = true;
                try {
                    let { deposit } = this;
                    let posted = new FormData();

	                if (deposit.nama_paket.length > 45) {
		                this.$toast.error("Nama paket tidak boleh menelebihi 45 karakter");
		                this.isSubmit = false;
		                return;
	                }
                    
                    Object.keys(deposit).forEach(function (key) {
                        posted.append(key, deposit[key])
                    })
                    
                    let url = this.isEditMode ? this.apiEndPoint.update : this.apiEndPoint.create;

                    const response = await connection.post(
                        url, 
                        posted, 
                        connection.contentType.form
                    );
                    
                    if (response.data.status === true) {
                        this.isSubmit = false;
                        this.back()
                        this.$toast.success(response.data.msg)
                    } else {
                        this.isSubmit = false;
                        this.$toast.error(response.data.msg)
                    }
                } catch (e) {
                    this.$catch_error_response(e);
                    this.isSubmit = false;
                }
            },
        },
    }
</script>

<style scoped>
    .set-margin {
        margin-top: 70px;
    }

    .mx-min-20 {
      margin-left: -20px;
      margin-right: -20px;
      width: auto;
    }

    .tooltip-inner {
        text-align: left !important;
    }
</style>